import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Header from "../../common/header";
import { Amplify } from "aws-amplify";
import {
  getCurrentUser,
  signInWithRedirect,
  fetchAuthSession,
  fetchUserAttributes,
  signOut,
} from "@aws-amplify/auth";
import { Hub } from "aws-amplify/utils";
import BounceLoader from "react-spinners/BounceLoader";
import LoadingOverlay from "../../common/Loader";
import { axiosClient, config } from "../../Services/Config";
// var apiConfig = require('../../Services/constant.json')[process.env.REACT_APP_ENV || 'dev'];

const { REACT_APP_ENV } = process.env;
let apiConfig = require("../../Services/constant.json")[REACT_APP_ENV.trim()];

import { withRouter } from "react-router-dom";



const loaderStyle = {
  color: "#f3f3f3",
};
class login extends Component {
  constructor(props, context) {
    super(props, context);
  
    this.state = {
      email: "",
      password: "",
      switch1Value: false,
      user: "",
      spinnerLoading: false,
    };
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId: apiConfig.cognito.userPoolId,
          userPoolClientId: apiConfig.cognito.userPoolWebClientId,
          identityPoolId: apiConfig.cognito.identityPoolId,
          region: apiConfig.cognito.region,
          loginWith: {
            oauth: {
              domain: apiConfig.cognito.oauth.domain,
              scopes: apiConfig.cognito.oauth.scopes,
              redirectSignIn: [apiConfig.cognito.oauth.redirectSignIn],
              redirectSignOut: [apiConfig.cognito.oauth.redirectSignOut],
              responseType: apiConfig.cognito.oauth.responseType,
            },
          },
        },
      },
      Analytics: {
        disabled: false,
        autoSessionRecord: true,
        Pinpoint: {
          appId: apiConfig.cognito.analyticsAppId,
          region: "us-east-1",
          bufferSize: 1000,
          flushInterval: 5000,
          flushSize: 100,
          resendLimit: 5,
        },
      },
    });
  }
  
  componentDidMount = () => {
    const userinfo = localStorage.getItem("userinfo");
    if (userinfo) {
      this.props.history.push("/daily-summary");
    }

    Hub.listen("auth", async ({ payload }) => {
      if (payload.event === "signInWithRedirect") {
        try {
          const { username } = await getCurrentUser();
          const session = await fetchAuthSession();
          console.log("Session after redirect:", session);
          const idToken = session.tokens?.idToken;
          const jwtToken = idToken?.toString();
          const user = username.split("\\").pop();
          this.authorisation(user, jwtToken);
        } catch (error) {
          console.error("Error fetching user data after redirect:", error);
        }
      }
    });
   
  };

  handleEmail = (text) => {
    this.setState({ email: text });
  };
  handlePassword = (text) => {
    this.setState({ password: text });
  };
  handleLogin = async () => {
    await signOut();
    await signInWithRedirect();
  };
  authorisation = async (username, jwtToken) => {
    try {
      this.setState({ spinnerLoading: true, list: [] });
      var _self = this;
      if (username && jwtToken) {
        localStorage.setItem("token", jwtToken);
        let token = localStorage.getItem("token");
        var uname = username
          .replace("na-adfs_NA", "")
          .replace("na-adfs_", "")
          .replace("\\", "")
          .replace("@la-z-boy.com", "");
        // axiosClient.post('https://s080lexhab.execute-api.us-east-1.amazonaws.com/v1/auth/getrole', new URLSearchParams({ username: user.username }), { headers: { "Authorization": `${token}` } })
        axiosClient
          .post(
            apiConfig.base_url + "/auth/getrole",
            new URLSearchParams({ username: uname }),
            { headers: { Authorization: `${token}` } },
          )
          .then((result) => {
            if (result.data.status == 200) {
              this.setState({ spinnerLoading: false });
              let user = { username: uname };
              if (result.data.data == undefined) {
                alert("Authentication failed ");
                return;
              }
              if (result.data.data && result.data.data.length == 0) {
                alert("Authentication failed ");
                return;
              }
              user.roleinfo = result.data.data;
              if (
                user.roleinfo.tasks.indexOf("DCGViewAdminReports") != -1 ||
                user.roleinfo.tasks.indexOf("DCGManageGlobalItems") != -1
              ) {
                localStorage.setItem("userinfo", JSON.stringify(user));
                if (user.roleinfo.tasks.indexOf("DCGManageGlobalItems") != -1) {
                  _self.props.history.push("/daily-summary");
                } else {
                  _self.props.history.push("/daily-summary");
                }
                // console.log(user.roleinfo.tasks)
              } else {
                _self.props.history.push("/unauth");
              }
            } else {
              this.setState({ spinnerLoading: false });
              alert("Login Failed ");
            }
          })
          .catch((err) => {
            this.setState({ spinnerLoading: false });
            console.log(err);
          });
      } else {
        this.setState({ spinnerLoading: false });
        console.log("not a valid ");
      }
    } catch (error) {
      this.setState({ spinnerLoading: false });
      console.log("error signing in", error);
      alert("Login Failed ! Username or Password is incorrect ");
    }
  };


  render() {
    return (
      <div className="wrapper">
        <LoadingOverlay
          active={this.state.spinnerLoading}
          spinner={<BounceLoader />}
          className={loaderStyle}
        >
          <Header />
          <div className="content-wrapper" id="ml_0">
            <section className="content">
              <div className="container">
                <div className="login-box">
                  <h4 className="pt-4 pb-3 pl-5 mb-0">
                    <b>Sign into your account</b>
                  </h4>
                  <hr className="m-0" />
                  <div className="pt-4 pl-5 pr-5 pb-3 custom-forms">
                    <div className="form-group text-center">
                      <button
                        className="btn custom-button btn-block mt-4 mb-2"
                        onClick={() => this.handleLogin()}
                      >
                        Login with your LA-Z-BOY ACCOUNT
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </LoadingOverlay>

        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    );
  }
}

export default withRouter(login);
